/**
 * BOUSS — rail de vignettes de la fiche produit (façon Mertra).
 * Les visuels restent EMPILÉS et défilent avec la page (galerie en mode
 * « grid » une colonne) ; ce rail sticky liste les vignettes, sert de
 * raccourci (scroll vers l'image) et suit l'image visible.
 * Reconstruit automatiquement si la section est re-rendue (variante,
 * hydratation) : un MutationObserver ré-initialise quand le rail disparaît.
 */
const RAIL_CLASS = 'bouss-media-rail';

function buildRail(gallery) {
  // En mode grid, le <slideshow-component> (et ses slideshow-slide) n'existe
  // que pour le carrousel MOBILE — il est display:none sur desktop. La pile
  // desktop est le ul.media-gallery__grid : c'est lui que le rail suit.
  const slides = [...gallery.querySelectorAll('.media-gallery__grid > li')];
  if (slides.length < 2) return;

  const rail = document.createElement('div');
  rail.className = RAIL_CLASS;
  const inner = document.createElement('div');
  inner.className = `${RAIL_CLASS}__inner`;
  rail.append(inner);

  const buttons = slides.map((slide, index) => {
    const image = slide.querySelector('img');
    if (!image) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `${RAIL_CLASS}__thumb`;
    button.setAttribute('aria-label', `Image ${index + 1}`);
    const thumb = document.createElement('img');
    thumb.src = image.currentSrc || image.src;
    thumb.alt = '';
    thumb.loading = 'lazy';
    button.append(thumb);
    button.addEventListener('click', () => {
      slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    inner.append(button);
    return button;
  });

  const setCurrent = (index) => {
    buttons.forEach((button, i) => {
      if (button) button.toggleAttribute('aria-current', i === index);
    });
  };
  setCurrent(0);

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) setCurrent(slides.indexOf(entry.target));
      }
    },
    { rootMargin: '-45% 0px -45% 0px' }
  );
  slides.forEach((slide) => observer.observe(slide));

  gallery.prepend(rail);
}

function init() {
  document
    .querySelectorAll('media-gallery[data-presentation="grid"]')
    .forEach((gallery) => {
      if (!gallery.querySelector(`.${RAIL_CLASS}`)) buildRail(gallery);
    });
}

init();
document.addEventListener('shopify:section:load', init);

// Re-rendus (choix de variante, hydratation de section) : ré-initialise
// dès qu'une galerie se retrouve sans rail.
let scheduled = false;
new MutationObserver(() => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    init();
  });
}).observe(document.body, { childList: true, subtree: true });
